import { render } from "./PoiDetail.vue?vue&type=template&id=d412c2b8"
import script from "./PoiDetail.vue?vue&type=script&lang=js"
export * from "./PoiDetail.vue?vue&type=script&lang=js"

import "./PoiDetail.vue?vue&type=style&index=0&id=d412c2b8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__